import React from "react";
import { Pill } from "../core/Badges";

export const INVOICE_STATUS: Record<string, string> = {
  draft: "bg-slate-100 text-slate-700 ring-slate-200", approved: "bg-sky-50 text-sky-800 ring-sky-200", sent: "bg-indigo-50 text-indigo-800 ring-indigo-200",
  paid: "bg-emerald-50 text-emerald-700 ring-emerald-200", overdue: "bg-rose-50 text-rose-700 ring-rose-200", void: "bg-slate-50 text-slate-400 ring-slate-200 line-through",
};
export const rm = (v: number) => `RM ${(v || 0).toLocaleString("en-MY", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const InvoiceStatus = ({ status, testId }: { status: string; testId?: string }) => <Pill className={INVOICE_STATUS[status]} testId={testId}>{status}</Pill>;
